export const AUTHORITY = 'AUTHORITY';
export const EXAMINEE = 'EXAMINEE';
export const CURRENTUSER = 'currentUser';
export const MYEXAM = 'myExam';
export const EXAMTIMELEFT = 'examTimeLeft';
export const SUBMITCONFIRM = 'submitConfirm';
export const SERVERTIME = 'serverTime';
export const EXAMPAPER = 'examPaper';
export const SUBMITALLPAPER = 'submitAllPaper';
